import { useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function EnquiryDialog({ product, open, onOpenChange, quote = false }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async () => {
    if (!form.name || !form.email) return toast.error("Please enter your name and email");
    setBusy(true);
    try {
      await api.post("/enquiries", {
        product_id: product?.id || "", sku: product?.sku || "",
        product_name: product?.name || "", ...form,
      });
      toast.success(quote ? "Quote request sent — ACP will send you pricing shortly" : "Enquiry sent — ACP will be in touch shortly");
      onOpenChange(false);
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch { toast.error(quote ? "Could not send quote request" : "Could not send enquiry"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="enquiry-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">{quote ? "Request a Quote" : "Product Enquiry"}</DialogTitle>
          <DialogDescription>
            {product?.name} <span className="font-mono">({product?.sku})</span>
            {quote ? " — tell us the quantity you need and we'll send you a price." : " — ask us about availability."}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><Label>Name</Label><Input data-testid="enquiry-name" value={form.name} onChange={set("name")} /></div>
          <div><Label>Email</Label><Input data-testid="enquiry-email" value={form.email} onChange={set("email")} /></div>
          <div><Label>Phone</Label><Input data-testid="enquiry-phone" value={form.phone} onChange={set("phone")} /></div>
          <div><Label>{quote ? "Quantity / details" : "Message"}</Label><Textarea data-testid="enquiry-message" value={form.message} onChange={set("message")} /></div>
          <Button data-testid="enquiry-submit" onClick={submit} disabled={busy}
            className="w-full bg-accent text-steel hover:bg-amber-600 font-semibold">
            {busy ? "Sending..." : quote ? "Send Quote Request" : "Send Enquiry"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
